export default function getAfterTripleAt (str) {
	return str.split('@@@')[1] || '';
}


